import React, { Component } from "react";
import InjectedCheckoutForm from "./CheckoutForm";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { withTranslation } from "react-i18next";
import withRouter from "helpers/withRouter";
import { connect } from "react-redux";

class StripePayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stripePromise: null,
    };
  }

  componentDidMount() {
    const stripeKey = this.props.user.stripe_publishable_key;

    if (stripeKey) {
      const stripePromise = loadStripe(stripeKey);
      this.setState({
        stripePromise,
      });
    }
  }

  render() {
    const { stripePromise } = this.state;

    if (!stripePromise) {
      return null;
    }

    return (
      <Elements stripe={stripePromise}>
        <InjectedCheckoutForm {...this.props} />
      </Elements>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(StripePayment))
);
